
import { computed, defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'VueBaseInput',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      required: true,
      validator: (value: string) => {
        return ['text', 'number', 'email', 'password', 'search', 'tel', 'textarea'].includes(value);
      },
    },
    id: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    labelInline: {
      type: Boolean,
      default: false,
    },
    blockStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fieldStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    errorMessageStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    labelStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buttonStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buttonText: {
      type: String,
      default: '',
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const showPassword = ref(false);

    const setType = computed(() => {
      if (props.type === 'password') {
        if (showPassword.value) return 'text';
        if (!showPassword.value) return 'password';
      }
      return props.type;
    });

    const onButtonClick = () => {
      if (props.type === 'password') {
        showPassword.value = !showPassword.value;
        return;
      } else {
        emit('onInputButtonClick');
      }
    };

    return {
      onButtonClick,
      showPassword,
      setType,
    };
  },
});
